import _0x2f8d7b from'./createTheme';var defaultTheme=_0x2f8d7b();export default defaultTheme;